export const PasswordPoliciesList: PasswordPolicies[] = [
    {
        title: 'minimunOneCapitalLetter',
        message: 'La contraseña debe tener minimo una letra minuscula',
        status: false,
        regex: '(?=\\w*[A-Z])',
    },
    {
        title: 'minimunOneEspecialCharacter',
        message: 'La contraseña debe tener minimo un caracter especial',
        status: false,
        regex: '(?=\\w*[@$!%*#?&])',
    },
    {
        title: 'maximunAndMinimunCharacters',
        message: 'La contraseña debe ser mayor a 6 caracteres y menor a 15',
        status: false,
        regex: '.{6,15}',
    },
    {
        title: 'differentPasswords',
        message: 'La nueva contraseña no puede ser igual a la anterior',
        status: false,
    },
    {
        title: 'confirmPassword',
        message: 'La nueva contraseña debe coincidir con la confirmación',
        status: false,
    },
];

export interface PasswordPolicies {
    title: string;
    message: string;
    status: boolean;
    regex?: string;
}
